import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { StatusHandleButtons } from "~/components/common/statuses/StatusHandleButtons";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import useLoader from "~/hooks/useLoader";
import { useDeals } from "~/hooks/vendors/useDeals";
import { isSuccess } from "~/utils/api/api_handler";
import { update as updateStatus } from "~/utils/api/vendors/DealStatus";

type Props = {
	backwardDisabled?: boolean;
	forwardDisabled?: boolean;
	nextStatusId: number;
	prevStatusId?: number | null;
};

export function StatusHandleVendorButtons({
	nextStatusId,
	prevStatusId = null,
	forwardDisabled = false,
	backwardDisabled = false
}: Props) {
	const { notify } = useNotification();
	const { Loader, showLoader, hideLoader } = useLoader();
	const dealId = useIdQueryHandler();
	const { data: deal, mutate: mutateDeal } = useDeals().show(dealId);
	if (deal === null) return null;

	const handleUpdateStatus = async (statusId: number): Promise<void> => {
		showLoader();
		const result = await updateStatus(deal.id, statusId);
		if (isSuccess(result)) {
			await mutateDeal?.();
			hideLoader();
			notify({ content: "更新しました。", variant: "success" });
			return;
		}
		hideLoader();
		notify({
			content: `エラーが発生しました。${result.message}`,
			variant: "error"
		});
	};
	const handleForwardStatus = async (): Promise<void> => {
		await handleUpdateStatus(nextStatusId);
	};
	const handleBackwardStatus = async (): Promise<void> => {
		if (prevStatusId === null) return;
		await handleUpdateStatus(prevStatusId);
	};
	return (
		<>
			<Loader />
			<StatusHandleButtons
				backwardDisabled={backwardDisabled}
				canBackward={prevStatusId !== null}
				forwardDisabled={forwardDisabled}
				handleBackwardStatus={handleBackwardStatus}
				handleForwardStatus={handleForwardStatus}
			/>
		</>
	);
}
